const SDK_VERSION = '7.51.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
